import Avatar, { AvatarSize } from "../../common/Avatar";
import styles from "./user.module.scss";

export interface IUserInfo {
  name?: string;
  phoneNumber?: string;
  imageUrl?: string;
}

export const User: React.FC<IUserInfo> = ({
  name = "",
  phoneNumber = "",
  imageUrl = "",
}: IUserInfo): JSX.Element => {
  return (
    <div className={styles.userInfoContainer}>
      <div className={styles.userProfileImg}>
        <Avatar avatarSize={AvatarSize.SMALL} src={imageUrl} alt={name} />
      </div>
      <div className={styles.userInfo}>
        <div className={styles.userName}>
          <p className={"subtitle2"}>{name}</p>
        </div>
        <div dir="ltr" className={"hint2"}>
          {phoneNumber}
        </div>
      </div>
    </div>
  );
};

export default User;
